import { ProgramCategory, ProgressStep } from '@monorepo/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TFunction = any;

export const getStepLabel = (step: ProgressStep, t: TFunction): string => {
  if (step.category === ProgramCategory.Evaluation) {
    const getOrdinal = (n: number): string => {
      if (n === 1) return t('progressBar.ordinals.first');
      if (n === 2) return t('progressBar.ordinals.second');
      if (n === 3) return t('progressBar.ordinals.third');
      return t('progressBar.ordinals.nth', { number: n });
    };
    const ordinal = getOrdinal(step.stepNumber);
    return `${ordinal} ${t('progressBar.labels.evaluationSuffix') || 'Evaluation'}`;
  } else if (step.category === ProgramCategory.Funded) {
    return t('progressBar.labels.funded');
  } else if (step.category === ProgramCategory.ScaleUp) {
    return t('progressBar.labels.scaleUp');
  }
  return step.name;
};
